import * as React from 'react';
import styled from 'styled-components';

import { Button } from '@creditornot/cb-button';
import { typographyClassName, typographyCss } from '@creditornot/cb-ingredients';
import { Stack } from 'common/components/cookbook/Stack';

const Root = styled(Stack)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  flex: 1;
  text-align: center;
  padding: 24px;
`;

const Message = styled.div`
  ${typographyCss.body};
  max-width: 600px;
`;

export const AppCrashNotification: React.FunctionComponent<{ message?: string }> = ({
  message,
}) => {
  return (
    <Root direction="column" alignItems="center" justifyContent="center" gap="regularXlarge">
      <div className={typographyClassName.title}>Ooops, the application just crashed!</div>
      {message && <Message>{message}</Message>}
      <Stack direction="row" gap="regularMedium">
        <Button
          size="small"
          variant="primary"
          onClick={() => window.location.reload()}
          iconPosition="start"
        >
          Reload page
        </Button>
        <Button
          size="small"
          variant="secondary"
          onClick={() => {
            window.location.href = '/';
          }}
          iconPosition="start"
        >
          Back to home
        </Button>
      </Stack>
    </Root>
  );
};
